<template>
  <div class="tr-step5B">
    <div class="highlight__card5B">
      <div class="highlight-header">HIGHLIGHTS</div>

      <HighlightWall5B />
      <HighlightDoor5B />
      <HighlightWindow5B />
    </div>
    <div class="tr-step5B__card">
      <div class="tr-step5B__mainHead">STEP:4 Roof & Wall Assembly Details</div>
      <div class="tr-step-4__subHead">(B) Wall</div>

      <div>
        <!-- Walls Accordians -->
        <div class="step5B-sections-wrap">
          <div class="step5B-sections">
            <v-icon color="white" left>mdi-wall</v-icon>

            Walls
          </div>
          <div class="expansion-panel-wrap">
            <v-expansion-panels focusable>
              <v-expansion-panel v-for="(item, i) in step5B.thermal_trans_walls" :key="i" :style="{ margin: '4px' }">
                <v-expansion-panel-header>
                  <!-- <div class="accordian__header--5B"> -->
                  <!-- <v-icon left>mdi-wall</v-icon> -->
                  {{ item.wall }}
                  <!-- </div> -->
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <div class="step5B__accordian-fields-wrap">
                    <div class="step5B__accordian-fields-row">
                      <OpaqueWall1Table :wall-index="i" />

                      <!-- <div v-else-if="item === `Opaque construction - 3 (Door/ Window frame)`"><OpaqueDoorWindowTable />0</div> -->
                    </div>
                  </div>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </div>
          <v-btn class="ma-2" outlined color="indigo" dense @click="addNewWall">
            <v-icon left> mdi-plus </v-icon>
            New wall
          </v-btn>
          <v-btn class="ma-2" outlined color="red" dense @click="removeWall">
            <v-icon left> mdi-delete </v-icon>
            Wall
          </v-btn>
        </div>
        <!-- <hr /> -->
        <!-- Doors Accordian -->

        <div class="step5B-sections-wrap">
          <div class="step5B-sections">
            <v-icon color="white" left>mdi-door</v-icon>

            Doors
          </div>
          <!-- When no doors -->
          <div class="zero-wrap" v-if="step5B.thermal_trans_doors.length === 0">
            <div class="zero-doors">
              <div>No Doors</div>
              <i class="light-icon-clipboard-x"></i>
            </div>
          </div>
          <!--  -->
          <div class="expansion-panel-wrap" v-else>
            <v-expansion-panels focusable>
              <v-expansion-panel v-for="(item, i) in step5B.thermal_trans_doors" :key="item.door + i" :style="{ margin: '4px' }">
                <v-expansion-panel-header>
                  <!-- <div class="accordian__header--5B"> -->
                  <!-- <v-icon left>mdi-door</v-icon> -->

                  {{ item.door }}
                  <!-- </div> -->
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <div class="step5B__accordian-fields-wrap">
                    <div class="step5B__accordian-fields-row">
                      <OpaqueDoorTable :door-index="i" />
                    </div>
                  </div>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </div>
          <v-btn class="ma-2" outlined color="indigo" dense @click="addNewDoor">
            <v-icon left> mdi-plus </v-icon>
            New door
          </v-btn>
          <v-btn v-if="doorCount > 0" class="ma-2" outlined color="red" dense @click="removeDoor">
            <v-icon left> mdi-delete </v-icon>
            Door
          </v-btn>
        </div>
        <!-- <hr /> -->
        <!-- Windows Accordians -->
        <div class="step5B-sections-wrap">
          <div class="step5B-sections">
            <v-icon color="white" left>mdi-window-closed-variant</v-icon>

            Windows
          </div>
          <!-- When no windows -->
          <div class="zero-wrap" v-if="step5B.thermal_trans_windows.length === 0">
            <div class="zero-doors">
              <div>No Windows</div>
              <i class="light-icon-clipboard-x"></i>
            </div>
          </div>
          <!--  -->
          <div class="expansion-panel-wrap">
            <v-expansion-panels focusable>
              <v-expansion-panel v-for="(item, i) in step5B.thermal_trans_windows" :key="item.window" :style="{ margin: '4px' }">
                <v-expansion-panel-header>
                  <!-- <div class="accordian__header--5B"> -->
                  <!-- <v-icon left>mdi-window-closed-variant</v-icon> -->
                  {{ item.window }}
                  <!-- </div> -->
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <div class="step5B__accordian-fields-wrap">
                    <div class="step5B__accordian-fields-row">
                      <OpaqueWindowTable :window-index="i" />
                    </div>
                  </div>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </div>
          <v-btn class="ma-2" outlined color="indigo" dense @click="addNewWindow">
            <v-icon left> mdi-plus </v-icon>
            New window
          </v-btn>
          <v-btn v-if="windowCount > 0" class="ma-2" outlined color="red" dense @click="removeWindow">
            <v-icon left> mdi-delete </v-icon>
            Window
          </v-btn>
        </div>
      </div>
      <hr style="margin-top:16px" />

      <div class="step5B__next-back-row">
        <v-btn color="blue-grey" class="ma-2 white--text" @click="$router.push({ name: 'Step5A' })"><v-icon left> mdi-arrow-left </v-icon> Back </v-btn>
        <v-btn color="blue-grey" class="ma-2 white--text" @click="$router.push({ name: 'Retv6A' })">Next <v-icon right> mdi-arrow-right </v-icon> </v-btn>
      </div>
    </div>
  </div>
</template>

<script>
import OpaqueWall1Table from '../tables/step5B/OpaqueWall1Table.vue';
import OpaqueDoorTable from '../tables/step5B/OpaqueDoorTable.vue';
import OpaqueWindowTable from '../tables/step5B/OpaqueWindowTable.vue';
import HighlightWall5B from '../highlights/HighlightWall5B.vue';
import HighlightDoor5B from '../highlights/HighlightDoor5B.vue';
import HighlightWindow5B from '../highlights/HighlightWindow5B.vue';

export default {
  components: {
    OpaqueWall1Table,
    OpaqueDoorTable,
    OpaqueWindowTable,
    HighlightWall5B,
    HighlightDoor5B,
    HighlightWindow5B,
  },
  data() {
    return {
      wallsCount: 0,
      windowCount: 0,
      doorCount: 0,
      // step5B: ['Wall-1', 'Opaque construction - 2 (Wall)', 'Opaque construction - 3 (Wall)', `Opaque construction - 3 (Door/ Window frame)`],
    };
  },
  computed: {
    schema: {
      get: function() {
        return this.$store.state.schema;
      },
      set: function(newSchema) {
        this.$store.dispatch('setSchema', newSchema);
      },
    },
    step5B: {
      get: function() {
        return this.$store.state.schema.inputs.step5B;
      },
      set: function(step5B) {
        this.$store.dispatch('setStep5B', step5B);
      },
    },
  },
  watch: {
    // doorCount: {
    //   handler: function() {
    //     this.calcDoorCount();
    //   },
    //   immediate: true,
    // },
  },
  mounted() {
    this.calcDoorCount();
  },
  methods: {
    calcDoorCount() {
      this.doorCount = this.step5B.thermal_trans_doors.length;
      console.log('Doors count', this.step5B.thermal_trans_doors.length);
    },
    addNewWall() {
      this.wallsCount = this.step5B.thermal_trans_walls.length;

      let newWall = {
        wall: `Wall ${this.wallsCount + 1}`,
        layer_arr_obj: [
          {
            layer: 'Layer 1',
            material: '',
            thermal_resistance: 0,
            material_n_resistance: '', //{material:'',thermal_resistance:''}
          },
        ],
        total_thermal_resistance: 0,
        u_value_wall: 0,
      };

      this.step5B.thermal_trans_walls.splice(this.wallsCount, 0, newWall);
    },
    removeWall() {
      this.wallsCount = this.step5B.thermal_trans_walls.length;
      if (this.wallsCount !== 1) {
        this.step5B.thermal_trans_walls.splice(this.wallsCount - 1, 1);
      }
    },
    addNewDoor() {
      this.doorCount = this.step5B.thermal_trans_doors.length;

      let newDoor = {
        door: `Door ${this.doorCount + 1}`,
        layer_arr_obj: [
          {
            layer: 'Layer 1',
            material: '',
            thermal_resistance: 0,
            material_n_resistance: '', //{material:'',thermal_resistance:''}
          },
        ],
        total_thermal_resistance: 0,
        u_value_door: 0,
      };

      this.step5B.thermal_trans_doors.splice(this.doorCount, 0, newDoor);
      console.log('Add new Doors', this.step5B.thermal_trans_doors.length);
    },
    removeDoor() {
      this.doorCount = this.step5B.thermal_trans_doors.length;

      // if (this.doorCount !== 1) {
      this.step5B.thermal_trans_doors.splice(this.doorCount - 1, 1);
      // }
      console.log('Remove Doors', this.step5B.thermal_trans_doors.length);
    },
    addNewWindow() {
      this.windowCount = this.step5B.thermal_trans_windows.length;
      let newWindow = {
        window: `Window ${this.windowCount + 1}`,
        layer_arr_obj: [
          {
            layer: 'Layer 1',
            material: '',
            thermal_resistance: 0,
            material_n_resistance: '', //{material:'',thermal_resistance:''}
          },
        ],
        total_thermal_resistance: 0,
        u_value_window: 0,
      };

      this.step5B.thermal_trans_windows.splice(this.windowCount, 0, newWindow);
    },

    removeWindow() {
      this.windowCount = this.step5B.thermal_trans_windows.length;
      this.step5B.thermal_trans_windows.splice(this.windowCount - 1, 1);
    },
  },
};
</script>

<style lang="scss">
.tr-step5B {
  padding: 32px;
  width: 100%;
  height: 100%;
}
.highlight__card5B {
  background-color: #fff;
  margin: 24px 0px;
  .highlight-header {
    background-color: #5a6978;

    padding: 8px 24px;
    color: #fff;
    font-size: 20px;
  }
}

.tr-step5B__card {
  background-color: #fff;
  padding: 38px;
  // width: 80%;
}
.tr-step5B__mainHead {
  margin: 0px 0px 8px 0;
  font-size: 28px;
  color: #343f4b;
  text-align: center;
}
.tr-step5B__subHead {
  margin: 0px 0px 18px 0;
  font-size: 20px;
  color: #343f4b;
  text-align: center;
}
.step5B-sections-wrap {
  outline: 1px solid #dedede;
  margin: 12px 0px;
  // border-top-left-radius: 4px;
  // border-top-right-radius: 4px;
}

.accordian__header--5B {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.step5B-sections {
  background-color: #949da7;
  color: #fff;
  padding: 12px;
  font-size: 20px;
  // border-top-left-radius: 4px;
  // border-top-right-radius: 4px;
}
.zero-wrap {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 6px;
  .zero-doors,
  .zero-windows,
  .zero-walls {
    display: flex;
    // flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 10px 12px;
    outline: 1px dotted #e9f2fa;
    background-color: #e9f2fa;
    color: #6db5f5;
    width: 40%;
    i {
      margin-left: 6px;
      font-size: 24px;
    }
  }
}

.expansion-panel-wrap {
  padding: 12px;
}
.step5B__action-btns {
  padding: 16px;
  display: flex;
  justify-content: space-evenly;
}

.step5B__summary {
  margin-top: 12px;
  .summary-head {
    font-size: 18px;
    color: #343f4b;
    font-weight: 800;
  }
}
.summary-block__wrap {
  display: flex;
  flex-direction: column;
  .summary-field__row {
    display: flex;
    justify-content: space-between;
  }
  .summary-field__label {
    font-size: 12px;
    color: #343f4b;
  }
}
.step5B__next-back-row {
  padding: 16px 0px 0px 0px;
  display: flex;
  justify-content: space-between;
}
</style>
